import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useRoute} from "vue-router/dist/vue-router";
import ProductList from "@/components/products/product-list.vue";
import {watch, ref} from "vue";
import {useCategoryProducts} from "@/hooks/useCategoryProducts";
import ProductsWithFilter from "@/components/common/products-with-filter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryView',
  setup(__props) {

const router = useRoute();
const category = ref(router.params.category as string);
const page = ref(1)
let {isLoading, data: products, error} = useCategoryProducts(category, page, [category, page])
watch(() => router.params.category, ()=>category.value = router.params.category as string, {deep: true})

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(ProductsWithFilter, {
        "is-loading": _unref(isLoading),
        products: _unref(products),
        title: category.value
      }, null, 8, ["is-loading", "products", "title"])
    ]),
    _: 1
  }))
}
}

})